export default "__VITE_ASSET__mRghmAt6__ 100w, __VITE_ASSET__CIBscCVl__ 200w, __VITE_ASSET__BbrxXinB__ 300w";